import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, Users, Star, ChevronLeft, ChevronRight } from 'lucide-react';

const VITALIS_LOGO = "https://vitalis-sports.ch/wp-content/uploads/2024/10/Asset-3.png";

// Testimonials data
const TESTIMONIALS = [
  { name: "Remo", text: "Ich werde immer herzlich und persönlich empfangen. Die Infrastruktur ist zudem sehr innovativ.", image: null },
  { name: "Lisbeth", text: "Dank der Analyse mit dem Cardioscan, konnte ich frühzeitig einem Herz-Kreislaufproblem vorbeugen.", image: null },
  { name: "Fiorina", text: "Ich schätze am Vitalis Fitness besonders die persönliche Betreuung der Fitnesstrainer/innen, die jederzeit möglich ist.", image: null },
  { name: "Gert", text: "Das Team ist persönlich, unkompliziert und sehr sympathisch. Vitalis hat super Öffnungszeiten.", image: null },
  { name: "Vanja", text: "Ich werde immer freundlich und sogar mit Namen begrüsst. Die Oeffungszeiten sind toll; ich kann praktisch rund um die Uhr trainieren.", image: null },
  { name: "Giuseppe", text: "Ich bin seit Jahren sehr zufrieden mit dem Vitalis. Das freundliche und kompetente Personal und die Vielfalt an Angeboten wie z. B. Sauna und Tennisplätze machen für mich den Unterschied.", image: null },
  { name: "Waldruth", text: "Ich bin im Rheintal noch nie in einem Fitnesscenter so gut betreut worden wie im Vitalis. Ich fühle mich hier sehr wohl.", image: null },
];

function TestimonialSlider() {
  const [current, setCurrent] = useState(0);
  const sliderRef = useRef(null);

  const next = () => setCurrent((c) => (c + 1) % TESTIMONIALS.length);
  const prev = () => setCurrent((c) => (c - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);

  useEffect(() => {
    const interval = setInterval(next, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative">
      <div className="overflow-hidden">
        <div 
          ref={sliderRef}
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="w-full flex-shrink-0 px-4">
              <div className="max-w-2xl mx-auto text-center">
                <p className="text-xl md:text-2xl text-gray-700 italic mb-6">"{t.text}"</p>
                <div className="flex flex-col items-center">
                  <p className="font-bold text-gray-900 text-lg">{t.name}</p>
                  {t.image && (
                    <img src={t.image} alt={t.name} className="w-16 h-16 rounded-full object-cover mt-4" />
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 p-2 bg-white/80 hover:bg-white rounded-full shadow-lg transition-colors">
        <ChevronLeft className="h-6 w-6 text-gray-700" />
      </button>
      <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 p-2 bg-white/80 hover:bg-white rounded-full shadow-lg transition-colors">
        <ChevronRight className="h-6 w-6 text-gray-700" />
      </button>
      <div className="flex justify-center gap-2 mt-6">
        {TESTIMONIALS.map((_, i) => (
          <button 
            key={i} 
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rounded-full transition-colors ${i === current ? 'bg-orange-500' : 'bg-gray-300'}`}
          />
        ))}
      </div>
    </div>
  );
}

export default function Home() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Extranet Banner */}
      <div className="bg-[#1e3a5f] text-white py-1.5 px-4 text-xs">
        <div className="max-w-7xl mx-auto flex items-center justify-end gap-3">
          <span className="text-white/70">Mitarbeiter-Bereich</span>
          <Link to="/login" className="flex items-center gap-1.5 bg-orange-500 hover:bg-orange-600 px-3 py-1 rounded text-xs font-medium transition-colors">
            <Users className="h-3 w-3" />
            Extranet
          </Link>
        </div>
      </div>

      {/* Header */}
      <header className="bg-white py-4 px-6 flex items-center justify-between relative z-50 shadow-sm">
        <a href="https://vitalis-sports.ch" className="flex items-center">
          <img src={VITALIS_LOGO} alt="Vitalis Sports" className="h-10" />
        </a>
        
        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-1">
          <Link to="/fitness" className="flex items-center gap-1 px-4 py-2 text-gray-700 hover:text-orange-500 font-medium transition-colors">
            Fitness <ChevronDown className="h-4 w-4" />
          </Link>
          <Link to="/racket" className="flex items-center gap-1 px-4 py-2 text-gray-700 hover:text-orange-500 font-medium transition-colors">
            Racket <ChevronDown className="h-4 w-4" />
          </Link>
          <Link to="/wellness" className="px-4 py-2 text-gray-700 hover:text-orange-500 font-medium transition-colors">
            Wellness
          </Link>
          <Link to="/ueber-uns" className="flex items-center gap-1 px-4 py-2 text-gray-700 hover:text-orange-500 font-medium transition-colors">
            Über uns <ChevronDown className="h-4 w-4" />
          </Link>
          <Link to="/kontakt" className="flex items-center gap-1 px-4 py-2 text-gray-700 hover:text-orange-500 font-medium transition-colors">
            Kontakt <ChevronDown className="h-4 w-4" />
          </Link>
        </nav>
        
        <div className="flex items-center gap-4">
          <a href="https://www.courtsonline.ch/?a=Ng==" target="_blank" rel="noopener noreferrer" className="hidden sm:block bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded font-bold text-sm tracking-wide transition-colors">
            PLATZ BUCHEN
          </a>
          <button onClick={() => setMenuOpen(!menuOpen)} className="lg:hidden p-2 hover:bg-gray-100 rounded transition-colors">
            {menuOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="fixed inset-0 bg-white z-40 pt-20 lg:hidden overflow-y-auto">
          <nav className="flex flex-col py-4">
            <Link to="/fitness" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">Fitness</Link>
            <Link to="/racket" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">Racket</Link>
            <Link to="/wellness" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">Wellness</Link>
            <Link to="/ueber-uns" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">Über uns</Link>
            <Link to="/kontakt" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">Kontakt</Link>
            <div className="px-6 py-6">
              <a href="https://www.courtsonline.ch/?a=Ng==" target="_blank" rel="noopener noreferrer" className="block w-full bg-orange-500 hover:bg-orange-600 text-white px-6 py-4 rounded font-bold text-center transition-colors">
                PLATZ BUCHEN
              </a>
            </div>
          </nav>
        </div>
      )}

      {/* Hero Section with Video */}
      <section className="relative h-[85vh] overflow-hidden">
        <div className="absolute inset-0">
          <iframe
            src="https://player.vimeo.com/video/1026391498?background=1&autoplay=1&loop=1&muted=1&quality=1080p"
            className="absolute w-[177.77vh] min-w-full min-h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            frameBorder="0"
            allow="autoplay; fullscreen"
            title="Vitalis Sports Video"
          />
          <div className="absolute inset-0 bg-black/40" />
        </div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-6xl md:text-8xl lg:text-9xl font-black text-orange-500 leading-none tracking-tight drop-shadow-lg">
            Mis Rhintl
          </h1>
          <h1 className="text-6xl md:text-8xl lg:text-9xl font-black text-orange-500 leading-none tracking-tight mt-2 drop-shadow-lg">
            Mis Fitness
          </h1>
          <a href="#angebot" className="mt-12 flex flex-col items-center text-white hover:text-orange-400 transition-colors">
            <span className="text-sm tracking-widest uppercase mb-2">Entdecke unser Angebot</span>
            <ChevronDown className="h-8 w-8 animate-bounce" />
          </a>
        </div>
      </section>

      {/* Angebot Section */}
      <section id="angebot" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <p className="text-sm tracking-widest text-gray-500 uppercase mb-3">Unser Angebot</p>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900">Familiär, herzlich, kompetent und modern.</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <Link to="/fitness" className="group block text-center">
              <div className="aspect-square rounded-xl overflow-hidden mb-6 relative shadow-lg">
                <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80" alt="Fitness" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
              <span className="inline-block bg-orange-500 text-white px-8 py-3 rounded font-bold text-lg group-hover:bg-orange-600 transition-colors">
                Fitness
              </span>
            </Link>
            <Link to="/wellness" className="group block text-center">
              <div className="aspect-square rounded-xl overflow-hidden mb-6 relative shadow-lg">
                <img src="https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80" alt="Wellness" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
              <span className="inline-block bg-orange-500 text-white px-8 py-3 rounded font-bold text-lg group-hover:bg-orange-600 transition-colors">
                Wellness
              </span>
            </Link>
            <Link to="/racket" className="group block text-center">
              <div className="aspect-square rounded-xl overflow-hidden mb-6 relative shadow-lg">
                <img src="https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=800&q=80" alt="Racket" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
              <span className="inline-block bg-orange-500 text-white px-8 py-3 rounded font-bold text-lg group-hover:bg-orange-600 transition-colors">
                Racket
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* Öffnungszeiten Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">Öffnungszeiten</h2>
            <p className="text-gray-600">Für Fitness-Mitglieder und Sportgäste 365 Tage offen.</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Betreute Zeiten */}
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-orange-500">Betreute Zeiten</h3>
              <div className="space-y-4">
                <div>
                  <p className="text-sm text-orange-500 font-medium">Winter Sept. - Mai</p>
                  <p className="text-gray-700">Mo-Fr: 08:30 – 21:30</p>
                  <p className="text-gray-700">Sa/So: 08:30 – 16:00</p>
                </div>
                <div>
                  <p className="text-sm text-orange-500 font-medium">Sommer Mai - August</p>
                  <p className="text-gray-700">Mo-Fr: 08:30 – 21:00</p>
                  <p className="text-gray-700">Sa/So: 08:30 – 13:00</p>
                </div>
                <p className="text-xs text-gray-500">Sonntags im Juli & August unbetreut geöffnet.</p>
              </div>
            </div>
            
            {/* Fitness */}
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-orange-500">Fitness</h3>
              <div className="space-y-2">
                <p className="text-gray-700">Mo-Fr: 06:00 – 23:00</p>
                <p className="text-gray-700">Sa/So: 06:00 – 20:00</p>
                <p className="text-xs text-gray-500 mt-4">Eintritt bis 30 Minuten vor Schliessung möglich.</p>
              </div>
            </div>
            
            {/* Racketsport */}
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-orange-500">Racketsport</h3>
              <div className="space-y-2">
                <p className="text-gray-700">Mo-Fr: 06:00 – 23:00</p>
                <p className="text-gray-700">Sa/So: 06:00 – 20:00</p>
                <p className="text-xs text-gray-500 mt-4">Self-CheckIn möglich. Letzte Spielzeit 1h vor Schliessung.</p>
              </div>
            </div>
            
            {/* Sauna */}
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-orange-500">Sauna</h3>
              <div className="space-y-4">
                <div>
                  <p className="text-sm text-orange-500 font-medium">Winter Okt. - April</p>
                  <p className="text-gray-700">Mo-Fr: 13:30 – 21:30</p>
                  <p className="text-gray-700">Sa/So: 09:30 – 15:45</p>
                  <p className="text-xs text-gray-500">Do: Damensauna</p>
                </div>
                <div>
                  <p className="text-sm text-orange-500 font-medium">Sommer Mai - Sept.</p>
                  <p className="text-gray-700">Mo-Fr: 13:30 – 20:45</p>
                  <p className="text-gray-700">Sa: 09:30 – 12:45</p>
                  <p className="text-xs text-gray-500">So: geschlossen</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Self Check-In Video */}
          <div className="mt-12 text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Anleitung Self-Check-In</h3>
            <div className="max-w-2xl mx-auto aspect-video rounded-xl overflow-hidden shadow-lg">
              <iframe
                src="https://player.vimeo.com/video/1026390685"
                className="w-full h-full"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                title="Self Check-In Video"
              />
            </div>
          </div>
        </div>
      </section>

      {/* So gsehts us - Video Gallery */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-black text-gray-900">So gsehts us!</h2>
          </div>
          <div className="aspect-video rounded-xl overflow-hidden shadow-2xl">
            <iframe
              src="https://player.vimeo.com/video/1026391498"
              className="w-full h-full"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              title="Vitalis Sports Tour"
            />
          </div>
        </div>
      </section>

      {/* Racket CTA */}
      <section className="py-20 bg-[#1e3a5f]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4">Tennis? Badminton? Squash?</h2>
          <h3 className="text-2xl md:text-3xl font-bold text-orange-500 mb-8">Jetzt Platz reservieren!</h3>
          <a 
            href="https://www.courtsonline.ch/?a=Ng==" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-10 py-4 rounded font-bold text-lg transition-colors"
          >
            PLATZ BUCHEN
          </a>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-black text-gray-900">Das sagen unsere Member</h2>
          </div>
          <TestimonialSlider />
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <img src={VITALIS_LOGO} alt="Vitalis Sports" className="h-10 mb-4 brightness-0 invert opacity-70" />
              <p className="text-sm">Dein familiäres Fitness- und Sportcenter im Rheintal.</p>
            </div>
            <div>
              <h4 className="font-bold text-white mb-4">Angebot</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/fitness" className="hover:text-white transition-colors">Fitness</Link></li>
                <li><Link to="/racket" className="hover:text-white transition-colors">Racket</Link></li>
                <li><Link to="/wellness" className="hover:text-white transition-colors">Wellness</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-white mb-4">Kontakt</h4>
              <ul className="space-y-2 text-sm">
                <li>Rorschacherstrasse 43</li>
                <li>9450 Lüchingen/Altstätten</li>
                <li>+41 71 755 50 66</li>
                <li>info@vitalis-sports.ch</li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-white mb-4">Extranet</h4>
              <p className="text-sm mb-4">Mitarbeiter-Bereich für Planung und Verwaltung.</p>
              <Link to="/login" className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded text-sm font-medium transition-colors">
                <Users className="h-4 w-4" />
                Anmelden
              </Link>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm">© 2026 Vitalis Sports. Alle Rechte vorbehalten.</p>
            <div className="flex gap-6 text-sm">
              <a href="https://vitalis-sports.ch/impressum/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Impressum</a>
              <a href="https://vitalis-sports.ch/datenschutzerklaerung/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Datenschutz</a>
              <a href="https://vitalis-sports.ch/cookie-richtlinie-eu/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Cookie-Richtlinie</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
